const eventClickPromoHomePage = (params, category) => {
  if (typeof window !== 'undefined' && params) {
    (window as any)?.dataLayer?.push({
      event: `promotionClick`,
      eventCategory: `ecommerce promotion`,
      eventLabel: category,
      ecommerce: {
        promoView: {
          promotions: [params],
        },
      },
    });
  }
};
export default eventClickPromoHomePage;
